



































import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import SingleCreditCardForm from '../../Form/SingleCreditCard/SingleCreditCardForm.vue';
import LabelCreditCardDiscount from '@/shared/components/Labels/LabelCreditCardDiscount.vue';

import { ECardStep, EPaymentMethod, EPaymentMethodTypes } from '@/helpers/enums';
import { Payment } from '@/classes/Checkout/Payment';
import { ICheckoutCartOffer } from '@/interfaces/Checkout';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    SingleCreditCardForm,
    LabelCreditCardDiscount,
  }
})
export default class SingleCreditCard extends Vue {
  public $refs!: {
    creditCardForm: SingleCreditCardForm,
  };

  @CheckoutModule.Mutation
  private selectPaymentConditionId!: Function;

  @CheckoutModule.Mutation
  private setPaymentConditionId!: Function;

  @CheckoutModule.Mutation
  private setMainPaymentCondition!: Function;

  @CheckoutModule.Mutation
  private setSecondPaymentCondition!: Function;

  @CheckoutModule.Getter('selectedOffer')
  private offer: ICheckoutCartOffer;

  @CheckoutModule.Getter
  private getOfferPaymentConditionIdByMethodCode!: any;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment: Payment;

  private get creditCard () {
    return this.payment.getPaymentMethod(EPaymentMethod.creditCard);
  }

  private get creditCardsTreated(): any {
    return this.payment.cards.options;
  }

  private get hasCreditCard(): any {
    return this.creditCardsTreated && this.creditCardsTreated.length > 0;
  }

  private get customerMainCreditCard(): any {
    return this.payment.cards.main;
  }

  private get creditCardInstallmentsTreated() {
    const installments = this.payment.cards.installments;

    return (
      installments &&
      installments.map((installment: any) => {
        return {
          ...installment,
          text: this.buildCreditCardInstallment(
            installment.number,
            installment.amount
          )
        };
      })
    );
  }

  private get creditCards() {
    return this.payment.cards.options;
  }

  private get creditCardMethod() {
    return this.payment.getPaymentMethod(EPaymentMethod.creditCard);
  }

  private get creditCardSelectedInstallment() {
    return this.creditCardMethod.installment;
  }

  private get stepCreditCardSelected() {
    return this.payment && this.payment.getPaymentMethod(EPaymentMethod.creditCard) && this.payment.getPaymentMethod(EPaymentMethod.creditCard).step;
  }

  private get isStepNewCard() {
    return this.stepCreditCardSelected === ECardStep.new;
  }

  private get showEmpiricusCardMessage() {
    return process.env.VUE_APP_EMPIRICUS_CARD_MESSAGE_TOGGLE_FEATURE === 'true';
  }

  private sendCardDigits() {
    this.$emit('sendCardDigits');
  }

  private setCardStep(cardStep: any) {
    this.$emit('setCardStep', cardStep);
  }

  private selectPaymentCard(payload: any) {
    this.$emit('setCreditCard', payload);
  }

  private setPaymentCardInstallment(payload: any) {
    this.$emit('setCardInstallment', payload);
  }

  private closeModal() {
    this.$emit('closeModal');
  }

  private buildCreditCardInstallment(number: number, amount: number) {
    return `
      ${number}x ${this.$t('App.of')}
      ${this.$n(amount, 'currency')}
      ${number === 1 && amount > 0 && this.creditCardMethod.discount_percentage
    ? `(${this.creditCardMethod.discount_percentage}% de desconto)`
    : ''}
    `;
  }

  private showCreditCardsOptions() {
    this.payment.setPaymentMethodField(EPaymentMethod.creditCard, 'step', ECardStep.select);
  }

  public async validateForm() {
    const valid: boolean = await this.$refs.creditCardForm.validateForm();

    return valid;
  }

  private setOfferPaymentConditionId(type: EPaymentMethod) {
    const offerPaymentConditionId = this.getOfferPaymentConditionIdByMethodCode(type);

    this.setPaymentConditionId(offerPaymentConditionId);
  }

  async mounted() {
    await this.setOfferPaymentConditionId(EPaymentMethod.creditCard);

    this.setMainPaymentCondition({
      id: this.creditCardMethod && this.creditCardMethod.id,
      amount: this.creditCardMethod && this.creditCardMethod.cart_final_price,
    });

    this.setSecondPaymentCondition(null);
  }
}
